const SELECTED_CITY_KEY = 'parking-box:selected-city';

const isBrowser = typeof window !== 'undefined';

const getStorage = (): Storage | null => {
  if (!isBrowser) {
    return null;
  }

  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const readStoredSelectedCityId = (): string | null => {
  const storage = getStorage();
  if (!storage) {
    return null;
  }

  try {
    const raw = storage.getItem(SELECTED_CITY_KEY);
    if (!raw) {
      return null;
    }

    const normalized = raw.trim();
    return normalized.length > 0 ? normalized : null;
  } catch {
    return null;
  }
};

export const persistSelectedCityId = (cityId: string) => {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(SELECTED_CITY_KEY, cityId.trim());
  } catch {
    // ignore storage errors
  }
};

export const clearStoredSelectedCityId = () => {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    storage.removeItem(SELECTED_CITY_KEY);
  } catch {
    // ignore storage errors
  }
};
